import { SelectOptionsType } from '@/components/ui/form/FormSelect.tsx'

import { PromotionalOfferForFanFormValues } from './validation'

export const MIN_DICSOUNT_PERCENT = 5
export const MAX_DISCOUNT_PERCENT = 40

export const subscriptionPercentOptions: SelectOptionsType = Array.from(
  { length: (MAX_DISCOUNT_PERCENT - MIN_DICSOUNT_PERCENT) / 5 + 1 },
  (_, i) => MIN_DICSOUNT_PERCENT + i * 5,
).map((value) => ({ value: String(value), label: `${value}% discount` }))

export const monthsOptions = Array.from({ length: 12 }, (_, i) => i + 1).map(
  (value) => ({
    value: String(value),
    label: `${value} month${value > 1 ? 's' : ''}`,
  }),
)

export const daysOptions = Array.from({ length: 7 }, (_, i) => i + 1).map(
  (value) => ({
    value: String(value),
    label: `${value} day${value > 1 ? 's' : ''}`,
  }),
)

export const discountTypes = [
  { id: 'subscription', name: 'Discount subscription' },
  { id: 'free-trial', name: 'Free trial' },
] as const

export const promotionalOfferFormDefaultValues: PromotionalOfferForFanFormValues =
  {
    type: 'subscription',
    subscription: {
      percent: subscriptionPercentOptions[0].value,
      duration: monthsOptions[0].value,
    },
    freeTrial: {
      duration: daysOptions[daysOptions.length - 1].value,
      offerExpiration: daysOptions[daysOptions.length - 1].value,
    },
  }
